import { Container, Spinner } from '@tabeo/scarf'
import { children } from '@tabeo/sharpei/utils/propTypes'
import PropTypes from 'prop-types'
import React from 'react'

const Content = ({ children, isLoading, ...rest }) => (
  <Container
    py={[5, 6]}
    px={[3, 4]}
    maxWidth="960px"
    boxSizing="content-box"
    mx="auto"
    {...rest}
    wrapProps={{
      minHeight: '100vh',
      ...rest.wrapProps,
    }}
    width="auto"
  >
    {isLoading ? <Spinner /> : children}
  </Container>
)

Content.propTypes = {
  children,
  isLoading: PropTypes.bool,
}

export default Content
